/**
 * Recursively flatten nested sub_questions into a single flat array.
 * Each sub-question retains its parent_question_id, depth, and display_conditions.
 */
export const flattenQuestions = (questions: any[]): any[] => {
  const result: any[] = []
  const processedIds = new Set()

  const processQuestion = (q: any) => {
    const id = q.id || q.temp_id
    if (!id || processedIds.has(id)) return
    processedIds.add(id)

    const { sub_questions, ...flatQ } = q
    result.push(flatQ)
    if (sub_questions && sub_questions.length > 0) {
      const sortedSubs = [...sub_questions].sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0),
      )
      sortedSubs.forEach((sq: any) => processQuestion(sq))
    }
  }

  const rootQuestions = questions
    .filter((q) => !q.parent_question_id && !q.parent_temp_id)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  if (rootQuestions.length > 0) {
    rootQuestions.forEach((q) => processQuestion(q))
    questions.forEach((q) => processQuestion(q))
  } else {
    const sortedAll = [...questions].sort(
      (a, b) => (a.order ?? 0) - (b.order ?? 0),
    )
    sortedAll.forEach((q) => processQuestion(q))
  }

  return result
}
